import { Injectable } from '@angular/core';
import { MenuItem } from '../../ui/dtos/menu-item';
import { BehaviorSubject, filter, map } from 'rxjs';

interface MenuState {
  menuItemsRegistered: boolean;
  menuItems: MenuItem[];
}

@Injectable({
  providedIn: 'root',
})
export class SideBarMenuService {
  private menuStateSubject = new BehaviorSubject<MenuState>({
    menuItemsRegistered: false,
    menuItems: [],
  });

  menuItems$ = this.menuStateSubject.asObservable().pipe(
    filter((state) => state.menuItemsRegistered),
    map((state) => state.menuItems)
  );

  registerMenuItems(menuItems: MenuItem[]): void {
    this.menuStateSubject.next({
      menuItemsRegistered: true,
      menuItems,
    });
  }

  appendMenuItem(menuItem: MenuItem): void {
    const currentState = this.menuStateSubject.value;
    this.menuStateSubject.next({
      ...currentState,
      menuItems: [...currentState.menuItems, menuItem],
    });
  }
}
